import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'

/**
 * The appointment behind an estimate, work order or invoice (US-37724).
 *
 * Reaches the same controller whether the caller is a signed-in portal user or someone who
 * followed a texted {CONFIRM_LINK} — the session branch and the guest branch both resolve to
 * the client that owns the event, and the core API refuses anything else.
 */
const appointmentService = () => {
  return {
    get: id => {
      const path = routesUtils.getApiPath(API.APPOINTMENT_DETAIL, { id })
      return httpClient.get(path)
    },
    // 'confirmed' | 'declined' — the only two a client may set. arrived, noShow and cancelled
    // are the shop's, and the API refuses them from this surface.
    setBookingState: (id, bookingState) => {
      const path = routesUtils.getApiPath(API.APPOINTMENT_DETAIL, { id })
      return httpClient.put(path, { bookingState })
    },
  }
}

export default appointmentService
